import { frontendURL } from 'dashboard/helper/URLHelper';
import ModulosVirtua from './pages/ModulosVirtua.vue';

export const routes = [
  {
    path: frontendURL('app/accounts/:accountId/modulos-virtua'),
    name: 'modulos_virtua',
    component: ModulosVirtua,
  },
];